import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import type {
  ApiSuccessEnvelope,
  CreateAffiliateRequest,
  CreateAffiliateResponseData,
} from "../../types/affiliates";
import { getPrivateInstance } from "../_privateInstance";

const postCreateAffiliate = async (
  payload: CreateAffiliateRequest,
): Promise<CreateAffiliateResponseData> => {
  const response = await getPrivateInstance().post<
    ApiSuccessEnvelope<CreateAffiliateResponseData>
  >(API_ROUTES.CREATE_AFFILIATE, payload);
  return response.data.data;
};

export const useCreateAffiliate = (): UseMutationResult<
  CreateAffiliateResponseData,
  Error,
  CreateAffiliateRequest
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["affiliates", "create"],
    mutationFn: postCreateAffiliate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["affiliates"] });
    },
  });
};
